import React from 'react'
import ReactDOM from 'react-dom/client'
import CyberPromptTool from './components/CyberPromptTool'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CyberPromptTool />
  </React.StrictMode>,
) 